
















































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import UserApi, {UpqForm} from "@/api/UserApi";
import {Inject} from "typescript-ioc";
import Pagination from '@/component/Pagination/index.vue'
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import PaginationTable from "@/component/Table/pagination-table.vue";
import User, {registerWayZh} from "@/model/User";

@Component({
    components: {
        Pagination,
        DeleteDialog,
        CreateDialog,
        RefreshButton,
        PaginationTable,
    },
})
export default class UserView extends Vue {
    @Inject
    private userApi!: UserApi

    @Ref()
    private ptable!: PaginationTable

    @Ref()
    private deleteDialog!: DeleteDialog

    private user = new User()

    private pqForm = this.initPqForm()

    private initPqForm(): UpqForm {
        const pqFormJson = this.$route.query.pqForm as string | null
        if (pqFormJson != null)
            return JSON.parse(pqFormJson)
        else
            return new UpqForm()
    }

    private refresh() {
        this.ptable?.refresh()
    }

    private async getPaging() {
        return this.userApi.paging(this.pqForm)
    }

    private registerWayZh = registerWayZh

    private registerWayFmt(user: User) {
        return this.registerWayZh[user.registerWay]
    }

    private async handleDetailClick(user: User) {
        this.$redirector.userDetail({
            id: user.id.toString(),
            pqForm: JSON.stringify(this.pqForm)
        })
    }

    private async handleDeleteClick(user: User) {
        this.user = user
        this.deleteDialog.open()
    }

    private async deleteUser() {
        await this.userApi.delete(this.user.id)
    }

    private get contentHeight() {
        return window?.innerHeight - 240
    }
}
